import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import { storableError } from '../../util/errors';
import { fetchBlogPostBySlug } from '../../util/blogApi';

export const fetchBlogPostThunk = createAsyncThunk(
  'BlogPostPage/fetchBlogPost',
  ({ slug }, { rejectWithValue }) => {
    return fetchBlogPostBySlug(slug).catch(e => rejectWithValue(storableError(e)));
  }
);

const initialState = {
  post: null,
  fetchInProgress: false,
  fetchError: null,
  showNotFound: false,
};

const blogPostPageSlice = createSlice({
  name: 'BlogPostPage',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchBlogPostThunk.pending, state => {
        state.fetchInProgress = true;
        state.fetchError = null;
        state.showNotFound = false;
        state.post = null;
      })
      .addCase(fetchBlogPostThunk.fulfilled, (state, action) => {
        state.fetchInProgress = false;
        state.post = action.payload?.post || null;
        state.showNotFound = !action.payload?.post;
      })
      .addCase(fetchBlogPostThunk.rejected, (state, action) => {
        state.fetchInProgress = false;
        state.fetchError = action.payload;
        state.post = null;
        state.showNotFound =
          action.payload?.status === 404 || action.payload?.message === 'not_found';
      });
  },
});

export default blogPostPageSlice.reducer;

export const loadData = (params, search) => dispatch => {
  const slug = params?.slug;
  if (!slug) {
    return Promise.resolve();
  }
  return dispatch(fetchBlogPostThunk({ slug }));
};
